// extracted by css-extract-rspack-plugin
export default {"MoveDashCardActionStyled":"DashCardTabMenu-module__MoveDashCardActionStyled___lxOJF"};